module.exports = __webpack_public_path__ + "img/header.5eae9217.svg";